module.exports = __webpack_public_path__ + "img/linkedin.0778ab8d.png";